import { Button, Divider, Select, Tooltip } from 'antd';
import React, { useMemo } from 'react';
import { CodeOutlined } from '@ant-design/icons';

import { prepareDropdown } from '../../utils/common';
import { filterClauseExcludeFields } from '../../constants/metainf';
import EventsQueryExposureModal from '../../containers/event/QueryExposureModal';
import { isNotEmptyClause } from '../../utils/filter';

const { Option } = Select;

const prepareDropdownSelectedClauses = (options, clauses = []) => {
  const filteredClauses = clauses.filter((clause) => {
    const hasField = clause.field !== undefined;
    return hasField && isNotEmptyClause(clause);
  });
  const clausesFields = filteredClauses.map((obj) => obj.field);
  const filteredOptions = options
    .flatMap((obj) => obj.fields)
    .filter((o) => clausesFields.includes(o.value));

  return clausesFields.length
    ? filteredClauses.map((clause) => ({
        index: clauses.findIndex((c) => c.id === clause.id) + 1,
        value: clause.id,
        name: filteredOptions.find((o) => o.value === clause.field)?.name,
      }))
    : [];
};

const getSelectOption = (data) => (
  <Option key={data.value} value={data.value}>
    <span style={{ color: '#BBB', marginRight: 5 }}>{`${data.index}.`}</span>
    {data.name}
  </Option>
);

const EventOthersFilter = ({
  othersFilter,
  onOthersChange,
  disabled,
  metainf,
  clauses,
  isFiltersValue,
  id,
}) => {
  const othersFilters = useMemo(
    () =>
      prepareDropdownSelectedClauses(
        prepareDropdown(metainf, false, filterClauseExcludeFields),
        clauses
      ),
    [clauses, metainf]
  );

  const renderButton = (onClick) => (
    <Tooltip placement="top" title="Expose a query">
      <Button
        icon={<CodeOutlined />}
        onClick={(e) => {
          onClick();
          e.target.blur();
        }}
        style={{ border: 'none' }}
      />
    </Tooltip>
  );

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
        <span>Compare with others by:</span>
        <Select
          dropdownMatchSelectWidth
          dropdownStyle={{ width: 'auto' }}
          value={othersFilter && othersFilters.length ? othersFilter : undefined}
          className="ant-select-border-bottom"
          allowClear
          onChange={(clauseId = null) => {
            onOthersChange(clauseId);
          }}
          disabled={disabled}
          style={{ width: 175, margin: '0 2px' }}
          getPopupContainer={(triggerNode) => triggerNode}
          virtual={false}
        >
          {othersFilters.map(getSelectOption)}
        </Select>
        {othersFilter && isFiltersValue && (
          <EventsQueryExposureModal clauseId={othersFilter} id={id} button={renderButton} />
        )}
      </div>
      <Divider style={{ margin: '10px 0px 0px ' }} />
    </>
  );
};

export default EventOthersFilter;
